document.addEventListener('click', function(event) {
  var thumb = event.target.closest('[data-db-thumb]');
  var previous = event.target.closest('[data-db-gallery-prev]');
  var next = event.target.closest('[data-db-gallery-next]');
  var trigger = thumb || previous || next;
  if (!trigger) return;

  var gallery = trigger.closest('[data-db-gallery]');
  if (!gallery) return;

  var thumbs = Array.from(gallery.querySelectorAll('[data-db-thumb]'));
  if (!thumbs.length) return;

  function activate(selectedThumb) {
    var main = gallery.querySelector('.db-gt2000__main-image');
    if (!main || main.tagName !== 'IMG') return;
    var full = selectedThumb.getAttribute('data-full');
    if (!full) return;

    main.setAttribute('src', full);
    main.removeAttribute('srcset');
    main.setAttribute('alt', selectedThumb.getAttribute('data-alt') || '');

    thumbs.forEach(function(button) {
      button.classList.remove('is-active');
      button.setAttribute('aria-pressed', 'false');
    });
    selectedThumb.classList.add('is-active');
    selectedThumb.setAttribute('aria-pressed', 'true');

    var track = gallery.querySelector('.db-gt2000__thumbs');
    if (track) {
      var targetLeft = selectedThumb.offsetLeft - Math.max(0, (track.clientWidth - selectedThumb.offsetWidth) / 2);
      track.scrollTo({ left: targetLeft, behavior: 'smooth' });
    }
  }

  if (thumb) {
    activate(thumb);
    return;
  }

  var activeIndex = thumbs.findIndex(function(button) {
    return button.classList.contains('is-active');
  });
  if (activeIndex < 0) activeIndex = 0;

  var targetIndex = previous ? activeIndex - 1 : activeIndex + 1;
  if (targetIndex < 0) targetIndex = thumbs.length - 1;
  if (targetIndex >= thumbs.length) targetIndex = 0;
  activate(thumbs[targetIndex]);
});
